<mat-form-field floatLabel="never" [ngClass]="classField()">
  <mat-select placeholder="..." [formControl]="control()">
    <mat-option [value]="'Rent'"><span translate>Rent</span></mat-option>
    <mat-option [value]="'Sell'"><span translate>Sell</span></mat-option>
    <mat-option [value]="'Split'"><span translate>Split</span></mat-option>
    <mat-option [value]="'OwnUse'"><span translate>Own use</span></mat-option>
  </mat-select>
</mat-form-field>